// 先暂时用any替代
type VueContext = any

export const getIdService = (() => {

	/*等待的异步队列*/
	const awaitQueue = [] as { resolve: (id: string) => void, reject: any }[]

	/*请求得到的id缓存*/
	const IdCache = (() => {
		// 缓存名称，将用不完的id放回localStorage
		const LINK_ID_SERVICE = '@@LINK_ID_SERVICE'
		const cacheString = window.localStorage.getItem(LINK_ID_SERVICE)
		const data = (window as any).Vue.observable({value: !!cacheString ? JSON.parse(cacheString) : []}) as { value: string[] }
		return {
			get: () => [...data.value],
			set: (ids: string[]) => {
				data.value = [...ids]
				window.localStorage.setItem(LINK_ID_SERVICE, JSON.stringify(data.value))
			},
		}
	})();

	/*请求id*/
	const requestId = (() => {
		const requestTenIds = async (context: VueContext): Promise<string[]> => {
			const {result} = await context.$http.post('action/link/appMobileInfo/getId')
			if (!result) {
				context.$nav.error("初始化id异常！")
				throw new Error('初始化id异常')
			}
			return result
		}
		const debounce = ((window as any).LinkUtils.debounce) as <T>(func: T, wait: number, immediate: boolean) => T
		return debounce(async (context: VueContext): Promise<void> => {
			const queue = awaitQueue.splice(0, awaitQueue.length)
			let ids: string[] = []
			while (ids.length < queue.length) {
				ids.push(...(await requestTenIds(context)))
			}
			queue.forEach(q => q.resolve(ids.pop()!))
			IdCache.set(ids)
		}, 100, false)
	})();

	return (context: VueContext) => {
		return {
			newId: async (): Promise<string> => {
				const cache = IdCache.get()
				if (cache.length > 0) {
					const availableId = cache.pop()
					IdCache.set(cache)
					return availableId!
				}
				return new Promise<string>((resolve, reject) => {
					awaitQueue.push({resolve, reject})
					requestId(context)
				})
			}
		}
	}

})();